const formatUtcOffset = (date: Date): string => {
  const offsetMinutes = -date.getTimezoneOffset();
  if (offsetMinutes === 0) {
    return "UTC";
  }

  const sign = offsetMinutes > 0 ? "+" : "-";
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const minutes = Math.abs(offsetMinutes) % 60;
  const minutesSuffix =
    minutes === 0 ? "" : `:${String(minutes).padStart(2, "0")}`;

  return `UTC${sign}${hours}${minutesSuffix}`;
};

export const formatCycleEnd = (iso: string): string => {
  const date = new Date(iso);
  const dateTime = date.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${dateTime} ${formatUtcOffset(date)}`;
};
